import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from "@angular/material/button";
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatOptionModule } from "@angular/material/core";
import { MatDatepickerModule } from "@angular/material/datepicker";
import { MatExpansionModule } from "@angular/material/expansion";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatIconModule } from "@angular/material/icon";
import { MatInputModule } from "@angular/material/input";
import { MatSelectModule } from "@angular/material/select";
import { MatTableModule } from '@angular/material/table';
import { MatPaginatorModule } from '@angular/material/paginator';

import { MatStepperModule } from "@angular/material/stepper";
import { BaseAffiliationContainerComponent } from "@shared/components/base-affiliation-container/base-affiliation-container.component";
import {
    AffiliationFormComponent
} from "@shared/components/base-affiliation-container/components/affiliation-form/affiliation-form.component";
import {
    AffiliationFuaFormComponent
} from "@shared/components/base-affiliation-container/components/affiliation-fua-form/affiliation-fua-form.component";
import {
    BeneficiaresDataFormComponent
} from "@shared/components/base-affiliation-container/components/beneficiares-data-form/beneficiares-data-form.component";
import {
    BeneficiaresDocumentsFormComponent
} from "@shared/components/base-affiliation-container/components/beneficiares-documents-form/beneficiares-documents-form.component";
import {
    BeneficiariesContainerComponent,
} from "@shared/components/base-affiliation-container/components/beneficiaries-container/beneficiaries-container.component";
import {
    CompanyFormComponent
} from "@shared/components/base-affiliation-container/components/company-form/company-form.component";
import {
    EmployeeFormComponent
} from "@shared/components/base-affiliation-container/components/employee-form/employee-form.component";
import {
    EmployeeFuaFormComponent
} from "@shared/components/base-affiliation-container/components/employee-fua-form/employee-fua-form.component";
import { ErrorMessageComponent } from '@shared/components/error-message/error-message.component';
import { MainHeaderComponent } from '@shared/components/main-header/main-header.component';
import { OnlyNumbersDirective } from "@shared/directives/only-numbers.directive";
import { UpperCaseDirective } from "@shared/directives/upper-case.directive";
import { TipoDocFilter } from "@shared/pipes/tipoDocFilter";
import { MomentService } from "@utils/functions/momentService";
import { NgxFileDropModule } from 'ngx-file-drop';
import { DepartmentsOperationsModalComponent } from './components/departments-operations-modal/departments-operations-modal.component';
import { MaterialModule } from './material.module';

// Pipes
import { ErrorAelComponent } from './components/error-ael/error-ael.component';
import { ErrorDialogComponent } from './components/error-ael/error-dialog/error-dialog.component';
import { LoadingAplComponent } from './components/loading-apl/loading-apl.component';
import { DateformatPipe } from './pipes/dateformat.pipe';
import { AelCifradoService } from 'ael-afiliacion-cifrado-utility';
import { AEL_CIFRADO_SERVICE_TOKEN } from '@utils/libs/cifrado/tokens';
import { DisableAutocompleteDirective } from './directives/disable-autocomplete.directive';
import { NaturalPersonOrNoProfileFoundComponent } from './components/natural-person-or-no-profile-found/natural-person-or-no-profile-found.component';
import { ForbiddenUserComponent } from './components/forbidden-user/forbidden-user.component';
import { AffiliationSpecialPopulationComponent } from './components/base-affiliation-container/components/affiliation-form/affiliation-special-population/affiliation-special-population.component';

@NgModule({
    declarations: [
        ErrorMessageComponent,
        MainHeaderComponent,
        BaseAffiliationContainerComponent,
        CompanyFormComponent,
        AffiliationFuaFormComponent,
        AffiliationFormComponent,
        AffiliationSpecialPopulationComponent,
        EmployeeFormComponent,
        EmployeeFuaFormComponent,
        DisableAutocompleteDirective,
        BeneficiariesContainerComponent,
        BeneficiaresDataFormComponent,
        BeneficiaresDocumentsFormComponent,
        DepartmentsOperationsModalComponent,
        ErrorAelComponent,
        ErrorDialogComponent,
        LoadingAplComponent,
        TipoDocFilter,
        UpperCaseDirective,
        OnlyNumbersDirective,
        DateformatPipe,
        NaturalPersonOrNoProfileFoundComponent,
        ForbiddenUserComponent
    ],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        MatCheckboxModule,
        MatCardModule,
        MatStepperModule,
        MatButtonModule,
        MatFormFieldModule,
        MatOptionModule,
        MatSelectModule,
        MatIconModule,
        MatInputModule,
        MatDatepickerModule,
        MatExpansionModule,
        MaterialModule,
        MatTableModule,
        MatPaginatorModule
    ],
    exports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        ErrorMessageComponent,
        MainHeaderComponent,
        NgxFileDropModule,
        BaseAffiliationContainerComponent,
        ErrorAelComponent,
        ErrorDialogComponent,
        LoadingAplComponent,
        TipoDocFilter,
        UpperCaseDirective,
        OnlyNumbersDirective,
        DateformatPipe
    ],
    providers: [MomentService,
        { provide: AEL_CIFRADO_SERVICE_TOKEN, useClass: AelCifradoService }
    ],


})
export class SharedModule { }
